
<div class="table">
  <p-table [value]="billets" autoLayout="true" [alwaysShowPaginator]="true"
      [totalRecords]="billets.length" [paginator]="false" #table
      [(selection)]="selectedBillets" dataKey="id"
      [globalFilterFields]="['customerName', 'identifier', 'sequence']"
      styleClass="easy-table">
      <!-- Botões legenda topo -->
      <ng-template pTemplate="caption">
          <button class="easymarine danger" (click)="cancelBillets()" type="button"
              title="Cancelar os boletos gerados no sistema">Cancelar boletos</button>

          <span class="p-input-icon-left">
              <i class="pi pi-search"></i>
              <input type="text" pInputText size="50" placeholder="Filtro por Fatura, Cliente, Carteira ou Conta"
                  [(ngModel)]="globalFilter" (input)="filterGlobal()" style="width:auto">
          </span>

          <span style="font-weight: bold">{{ 'TOTAL-REGISTERS' | translate }}:
              {{billets.length}}
           </span>
      </ng-template>
      <ng-template pTemplate="header">
          <tr>
              <th></th>
              <th colspan="3">Boletos selecionados: {{selectedBillets?.length}}</th>
              <th colspan="7"></th>
              <th class="text-right">Total:</th>
              <th class="text-right">{{totalBillets | number:'1.2-2'}}</th>
              <th class="text-right">{{totalPaid | number:'1.2-2'}}</th>

          </tr>
          <tr>
              <th class="text-center">
                  <input type="checkbox" class="primeCheckbox" (click)="selectAll()">
              </th>

              <th class="text-center" [pSortableColumn]="'sequence'">
                  Parcela
                  <p-sortIcon [field]="'sequence'"></p-sortIcon>
              </th>
              <th class="text-center">Boleto</th>
              <th class="text-center" *ngIf="checkIfHavePixCopyPasteOnList()">Pix</th>
              <th class="text-center" [pSortableColumn]="'customer'">
                  Cliente
                  <p-sortIcon [field]="'customer'"></p-sortIcon>
              </th>
              <th class="text-center" [pSortableColumn]="'group'">
                  Grupo
                  <p-sortIcon [field]="'group'"></p-sortIcon>
              </th>
              <th class="text-center" [pSortableColumn]="'issueDate'">
                  Emissão
                  <p-sortIcon [field]="'issueDate'"></p-sortIcon>
              </th>
              <th class="text-center" [pSortableColumn]="'dueDate'">
                  Vencimento
                  <p-sortIcon [field]="'dueDate'"></p-sortIcon>
              </th>
              <th class="text-center" [pSortableColumn]="'identifier'">
                  Nosso número
                  <p-sortIcon [field]="'identifier'"></p-sortIcon>
              </th>
              <th class="text-center" [pSortableColumn]="'idCarteiraCobranca'">
                  Conta
                  <p-sortIcon [field]="'idCarteiraCobranca'"></p-sortIcon>
              </th>
              <th class="text-center" [pSortableColumn]="'idCarteiraCobranca'">
                  Carteira
                  <p-sortIcon [field]="'idCarteiraCobranca'"></p-sortIcon>
              </th>
              <th class="text-center" [pSortableColumn]="'value'">
                  Valor
                  <p-sortIcon [field]="'value'"></p-sortIcon>
              </th>
              <th class="text-center" [pSortableColumn]="'valuePaid'">
                  Valor Pago
                  <p-sortIcon [field]="'valuePaid'"></p-sortIcon>
              </th>
              <th class="text-center">
                Log
              </th>
              <th class="text-center">
                Cancelado em:
              </th>
              <th class="text-center">
                  C. banco
              </th>
          </tr>
      </ng-template>
      <ng-template pTemplate="body" let-billet>
          <tr [ngClass]="{'inactive': !billet.active, 'paid': billet.paid}">
              <td class="text-center"
                  [pTooltip]="billet.anticipated ? 'Boleto antecipado não pode ser cancelado.' : (billet.paid ? 'O boleto já está pago.' : (!billet.active ? 'O boleto já se encontra cancelado.' : ''))"
                  tooltipPosition="bottom">
                  <p-tableCheckbox [value]="billet" *ngIf="canCancel(billet)">
                  </p-tableCheckbox>
              </td>

              <td class="text-center">
                  {{ billet?.sequence }}
              </td>
              <td class="text-center" [ngClass]="{'anticipated' : billet?.anticipated}">
                  <ng-container  >
                      <a *ngIf="billet?.active" [href]="billet?.documentUrl" target="_blank">
                          <app-barcode-icon *ngIf="billet?.registered && !billet.paid" [styleBillet]="'registered'"  [toolTipMsg]="getTooltip(billet)"></app-barcode-icon>
                          <app-barcode-icon *ngIf="billet.paid" [styleBillet]="'paid'"  [toolTipMsg]="getTooltip(billet)"></app-barcode-icon>
                          <ng-container *ngIf="!billet?.registered && !billet.paid && billet.processed">
                              <app-barcode-icon *ngIf="billet.active && billet.valuePaid > 0" [styleBillet]="'paid'"  [toolTipMsg]="getTooltip(billet)"></app-barcode-icon>
                              <app-barcode-icon *ngIf="!billet.valuePaid && isToday(billet)" [styleBillet]="'waiting'"  [toolTipMsg]="getTooltip(billet)"></app-barcode-icon>
                              <app-barcode-icon *ngIf="billet.active && !billet.valuePaid && !isToday(billet) && !billet.registered && !billet.refused" [styleBillet]="'pending'"  [toolTipMsg]="getTooltip(billet)"></app-barcode-icon>
                              <app-barcode-icon *ngIf="billet.refused && billet.active" [styleBillet]="'refused'"  [toolTipMsg]="getTooltip(billet)"></app-barcode-icon>
                          </ng-container>
                      </a>
                      <ng-container *ngIf="!billet?.registered && !billet?.paid && !billet?.processed && billet?.active">
                          <app-barcode-icon *ngIf="!billet.valuePaid && isToday(billet)" [styleBillet]="'waiting'"  [toolTipMsg]="'Aguardando o arquivo de retorno'"></app-barcode-icon>
                          <app-barcode-icon *ngIf="billet.active && !billet.valuePaid && !isToday(billet) && !billet.registered && !billet.refused" [styleBillet]="'pending'"  [toolTipMsg]="'Aguardando o arquivo de retorno'"></app-barcode-icon>
                      </ng-container>
                      <app-barcode-icon *ngIf="!billet?.active && !billet.paid" [styleBillet]="'canceled'"  [toolTipMsg]="billet.bankCanceledDate ? 'Boleto cancelado em: ' + getDateFormatted(billet.bankCanceledDate) : 'Boleto cancelado'"></app-barcode-icon>
                  </ng-container>
              </td>
              <td *ngIf="checkIfHavePixCopyPasteOnList()" class="text-center cursor-pointer">
                  <i *ngIf="checkIfHavePixCopyPaste(billet)" title="Pix Copia e Cola" class="pi pi-copy" (click)="copyToClipboard(billet)"></i>
              </td>
              <td [pTooltip]="billet.emailCollectionArray ? billet.emailCollectionArray.join('\n') : ''"
                  tooltipPosition="bottom">
                  {{ billet?.customerName }}
              </td>
              <td class="text-center">
                  {{ billet?.group ? billet?.group : 'Sem grupo' }}
              </td>
              <td class="text-center">
                  {{ billet?.issueDate | date:'dd/MM/yy'}}
              </td>
              <td class="text-center">
                  {{ billet?.dueDate | date:'dd/MM/yy' }}
              </td>
              <td class="text-center">
                  {{ billet?.identifier }}
              </td>
              <td class="text-center">
                  {{ billingPortfolio(billet).conta.nome }}
              </td>
              <td class="text-center">
                  {{ billingPortfolio(billet).nome }}
              </td>
              <td class="text-right">
                  {{ billet?.value | number:'1.2-2' }}
              </td>
              <td class="text-right" [pTooltip]="billet?.valuePaid > 0 ? getDateFormatted(billet.datePaid) : ''"
                  tooltipPosition="bottom">
                  {{ billet?.valuePaid | number:'1.2-2' }}
              </td>
              <td class="text-center">
                <i class="pi pi-question-circle text-gray-500 cursor-pointer"
                   (click)="showBilletLogs(billet.id)"
                   pTooltip="Ver logs do boleto"
                   tooltipPosition="top">
                </i>
              </td>
              <td class="text-center">
                {{ billet?.cancelDate   | date:'dd/MM/yy'}}
              </td>
              <td class="text-center"
                  [pTooltip]="!billet.active ? (billet.bankCanceled ? 'Data cancelamento: ' + getDateFormatted(billet.bankCanceledDate) : 'Não cancelado no banco') : ''"
                  tooltipPosition="bottom">
                  <span (click)="cancelBilletBank(billet)" *ngIf="!billet.active">
                      <i class="pi pi-check" style="color: green" *ngIf="billet.bankCanceled"></i>
                      <i class="pi pi-times" style="color: red" *ngIf="!billet.active && !billet.bankCanceled"></i>
                  </span>
              </td>
          </tr>
      </ng-template>
  </p-table>
</div>

